import React, { useRef, useState } from "react";
import classes from "./SigninScreen.module.css";
import { auth } from "../../../firebase";
import { useNavigate } from "react-router-dom";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { useDispatch } from "react-redux";
import { guestlogin, login } from "../../features/UserSlice";

const SigninScreen = ({ userEmail }) => {
  const [userInputEmail, setUserInputEmial] = useState(userEmail);
  const passwordRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const register = (e) => {
    e.preventDefault();
    createUserWithEmailAndPassword(
      auth,
      userInputEmail,
      passwordRef.current.value
    )
      .then((authUser) => {
        alert("Register Succesfull");
      })
      .catch((error) => {
        alert(error.message);
      });
  };

  const signin = (e) => {
    e.preventDefault();
    signInWithEmailAndPassword(auth, userInputEmail, passwordRef.current.value)
      .then((userCredential) => {
        // signed in
        navigate("/");
      })
      .catch((error) => {
        const errorMessage = error.message;
        // alert(errorMessage);
      });
  };
  const options = {
    method: "GET",
    headers: {
      accept: "application/json",
      Authorization:
        "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI5ZWI5YWNlOGYyN2Q0ZWEzNjA4N2I2YTBhNDNhY2EyZCIsInN1YiI6IjY0YTY3YmZkMDdmYWEyMDBjN2VjMDMwNSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.9Z04wgkmVL20VmJnDpUesSbyuMUiMEYzZqHWKqx7xxs",
    },
  };
  const signInAsGuest = () => {
    fetch(
      "https://api.themoviedb.org/3/authentication/guest_session/new",
      options
    )
      .then((response) => response.json())
      .then((response) => {
        dispatch(
          guestlogin({
            guestid: response.guest_session_id,
            guesttime: response.expires_at,
            guestreponse: response.success,
          })
        );
        dispatch(
          login({
            uid: response.guest_session_id,
            email: null,
          })
        );
        navigate("/");
      })
      .catch((err) => console.error(err));
  };

  return (
    <div className={classes.signinscreen_body}>
      <form>
        <h1>Sign In</h1>
        <input
          type="email"
          placeholder="Email"
          value={userInputEmail}
          onChange={(event) => setUserInputEmial(event.target.value)}
        />
        <input ref={passwordRef} placeholder="Password" type="password" />
        <button className={classes.signinscreen_button} onClick={signin}>
          Sign In
        </button>
        <h4>
          <span className={classes.signinscreen_gray}>New to Netflix? </span>
          <span className={classes.signupscreen_link} onClick={register}>
            sign Up now.
          </span>
        </h4>
        <span className={classes.signupscreen_guest} onClick={signInAsGuest}>
          sign in as a Guest
        </span>
      </form>
    </div>
  );
};

export default SigninScreen;
